module.exports = __webpack_public_path__ + "static/media/iros2022.823dfca5.png";